<template>
  <div>
    <v-form @submit.prevent="login">
      <div class="input-field">
        <div class="input-label">
          <span>{{ $t('login.username') }}</span>
          <span class="required">*</span>
        </div>
        <div>
          <v-text-field outlined flat
            v-model.lazy="username"
            @input="resetError()"
            :rules="requiredRules">
          </v-text-field>
        </div>
      </div>

      <div class="input-field">
        <div class="input-label">
          <span>{{ $t('login.password') }}</span>
          <span class="required">*</span>
        </div>
        <div>
          <v-text-field outlined flat
            type="password"
            v-model.lazy="password"
            @input="resetError()"
            :rules="requiredRules">
          </v-text-field>
        </div>
      </div>

      <!-- <div>
        <v-checkbox
          v-model="rememberme"
          @input="resetError()">
          <template v-slot:label>
            {{ $t('login.remember_me') }}
          </template>
        </v-checkbox>
      </div> -->

      <div v-if="error">
        <span class="required">
          <v-icon color="error" small>mdi-alert-circle-outline</v-icon>
          {{ $t('alert.try_again') }}
        </span>
      </div>

      <div class="actions">
        <v-btn block depressed type="submit" :disabled="!confirm"
          color="primary">
          {{ $t('login.login') }}
        </v-btn>
      </div>
    </v-form>

    <div class="links">
      <router-link :to="{name: 'signup'}"
        tag="div"
        class="link-element pointer-element">
        {{ $t('login.register') }}
      </router-link>
      <div class="sub-links">
        <router-link :to="{name: 'login', query: {step: 'forgot-username'}}"
          tag="div"
          class="link-element pointer-element">
          사용자명 찾기
        </router-link>
        /
        <router-link :to="{name: 'login', query: {step: 'forgot-password'}}"
          tag="div"
          class="link-element pointer-element">
          {{ $t('login.forgot_password') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {

    data() {
      return {
        username: "",
        password: "",
        // rememberme: false,

        requiredRules: [
          v => !!v || this.$t('alert.required')
        ],

        error: false,
      }
    },

    computed: {
      ...mapGetters({
        is_authenticated: 'auth/is_authenticated',
      }),

      confirm() {
        return this.username !="" && this.password !=""
      },
    },

    methods: {
      async login() {
        try {
          await this.$store.dispatch('auth/login', {
            username: this.username,
            password: this.password,
            // rememberme: this.rememberme,
          })
        } catch(e) {
          this.error = true
        } finally {
          if (!this.error) {
            this.$analytics.logEvent("login")
            this.$router.replace(this.$route.params.wantedRoute || { name: 'lab' })
          }
        }
      },

      resetError() {
        if (this.error) {
          this.error = false
        }
      },
    },
  }
</script>

<style scoped>
  .actions, .links {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
  }

  .sub-links {
    display: flex;
    justify-content: space-between;
  }
</style>


// WEBPACK FOOTER //
// src/components/shared_components/form/Login.vue